import { Text } from "@chakra-ui/react";
import { doc, getDoc, onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../service/firebase";

function OnlineState(props) {
  const [online, setOnline] = useState(false);
  useEffect(() => {
    if (!props?.id) return;
    const unsub = onSnapshot(doc(db, "isOnline", props?.id), (doc) => {
      setOnline(doc?.data()?.online);
    });

    return () => unsub();
  }, [props?.id]);
  return online ? (
    <Text color="#76C00D" fontSize={".6em"}>
      Online
    </Text>
  ) : (
    ""
  );
}

export default OnlineState;
